module.exports = __webpack_public_path__ + "img/3-3.574181c6.gif";